import { render, staticRenderFns } from "./Patients.vue?vue&type=template&id=5ea5f228&"
import script from "./Patients.vue?vue&type=script&lang=tsx&"
export * from "./Patients.vue?vue&type=script&lang=tsx&"
import style0 from "./Patients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports